/* eslint-disable */
import { getPermissionTree, getPermissionsByUserId } from '@/request/view/permissions';
import { RouteRecordRaw } from 'vue-router';
import { Toast } from '@/utils';
import store from '@/store/index';
import router from '@/router';
import loadsh from 'lodash';

export const routerArr: any = [
  {
    path: '/home',
    name: 'Dashboard',
    meta: {
      title: '首页',
      type: 'default',
    },
    component: () => import(/* webpackChunkName: "layout" */'@/layout/index.vue'),
    children: [
      {
        path: '/menu',
        name: 'menu',
        meta: {
          title: '权限配置',
          type: 'page',
        },
        component: () => import(/* webpackChunkName: "menu" */'@/views/menu/index.vue'),
      },
      {
        path: '/aftersalesmanagement',
        name: "aftersalesmanagement",
        meta: {
          title: '售后管理',
          type: 'page',
        },
        component: () => import(/* webpackChunkName: "aftersalesmanagement" */ '@/views/productcenter/index.vue'),
        children: [{
          path: "/aftersalerepair",
          name: "aftersalerepair",
          meta: {
            title: "日常报修",
            type: "page"
          },
          component: () => import(/* webpackChunkName: "aftersalerepair" */ '@/views/afterSaleRepair/pc/layout.vue')
        },
        {
          path: "/prototypemanagement",
          name: "样机管理",
          meta: {
            title: "样机管理",
            type: "page"
          },
          component: () => import(/* webpackChunkName: "prototypemanagement" */ '@/views/marketmanagement/prototypeManagement/index.vue')
        }, {
          path: "/aftersalevideomanagement",
          name: "aftersalevideomanagement",
          meta: {
            title: "视频管理",
            type: "page"
          },
          component: () => import(/* webpackChunkName: "aftersalevideomanagement" */ '@/views/afterSale/videoManagement/index.vue')
        },
        {
          path: "/aftersalebackup",
          name: "aftersalebackup",
          meta: {
            title: "数据备份",
            type: "page"
          },
          component: () => import(/* webpackChunkName: "aftersalebackup" */ '@/views/afterSale/dataBackup/index.vue')
        }, {
          path: "/aftersaledepartmentalrequirements",
          name: "aftersaledepartmentalrequirements",
          meta: {
            title: "跨部门需求",
            type: "page",
          },
          component: () => import(/* webpackChunkName: "aftersaledepartmentalrequirements" */ '@/views/departmentalRequirements/index.vue'),
        }
        ]
      },
      {
        path: "/productioncenter",
        name: "productioncenter",
        meta: {
          title: '生产中心',
          type: 'page',
        },
        component: () => import(/* webpackChunkName: "productioncenter" */ '@/views/productcenter/index.vue'),
        children: [
          {
            path: '/randomserial',
            name: 'randomserial',
            meta: {
              title: '机身编号',
              type: 'page',
            },
            component: () => import(/* webpackChunkName: "randomserial" */ '@/views/randomserial/index.vue'),
          },
          {
            path: '/repairequipment',
            name: 'repairequipment',
            meta: {
              title: '设备返修',
              type: 'page',
            },
            component: () => import(/* webpackChunkName: "repairequipment" */ '@/views/repair/index.vue'),
          },
          {
            path: '/productionInstruction',
            name: "productionInstruction",
            meta: {
              title: '生产计划',
              type: 'page',
              produceOrTpc: "produce",
            },
            component: () => import(/* webpackChunkName: "productionInstruction" */ '@/views/productionInstruction/index.vue'),
          },
          {
            path: '/inspection',
            name: "inspection",
            meta: {
              title: '日常质检',
              type: 'page',
              produceOrTpc: "produce",
            },
            component: () => import(/* webpackChunkName: "inspection" */ '@/views/productDaily/pc/index.vue'),
          },
          {
            path: '/product',
            name: "product",
            meta: {
              title: '日常生产',
              type: 'page',
              produceOrTpc: "produce",
            },
            component: () => import(/* webpackChunkName: "product" */ '@/views/productDaily/pc/produceIndex.vue'),
          },
          {
            path: '/warehouse',
            name: "warehouse",
            meta: {
              title: '成品仓库',
              type: 'page',
              produceOrTpc: "produce",
            },
            component: () => import(/* webpackChunkName: "warehouse" */ '@/views/productDaily/warehouse/index.vue'),
          },
          {
            path: "/qualityInspectionIssues",
            name: "qualityInspectionIssues",
            meta: {
              title: '质检问题',
              type: 'page',
              produceOrTpc: "produce",
            },
            component: () => import(/* webpackChunkName: "qualityInspectionIssues" */ '@/views/productDaily/problem/layout.vue'),
          }
        ],
      }, {
        path: "/materialwarehouse",
        name: "materialwarehouse",
        meta: {
          title: "物料仓库",
          produceOrTpc: "produce",
          type: "page"
        },
        component: () => import(/* webpackChunkName: "materialwarehouse" */ '@/views/productDaily/warehouse/index.vue')
      }, {
        path: "/rdmanagement",
        name: "rdmanagement",
        meta: {
          title: "研发管理",
          type: "page"
        },
        component: () => import(/* webpackChunkName: "aftersalesmanagement" */ '@/views/productcenter/index.vue'),
        children: [
          {
            path: "/projectmanagement",
            name: "项目管理",
            meta: {
              title: "项目管理",
              type: "page"
            },
            component: () => import(/* webpackChunkName: "rdmanagement" */ '@/views/rdmanagement/pc/index.vue')
          },
          {
            path: "/materialcode",
            name: "物料编码",
            meta: {
              title: "物料编码",
              type: "page"
            },
            component: () => import(/* webpackChunkName: "materialcode" */ '@/views/materialcode/index.vue')
          },
          {
            path: "/rnddepartmentAnnouncement",
            name: "部门公告",
            meta: {
              title: "部门公告",
              type: "page",
            },
            component: () => import(/* webpackChunkName: "materialcode" */ '@/views/rdmanagement/publicAnnouncement/index.vue')
          }
        ]

      }, {
        path: "/marketmanagement",
        name: "marketManagement",
        meta: {
          title: "市场管理",
          type: "page"
        },
        component: () => import(/* webpackChunkName: "aftersalesmanagement" */ '@/views/productcenter/index.vue'),
        children: [
          {
            path: "/marketdepartmentalrequirements",
            name: "marketdepartmentalrequirements",
            meta: {
              title: "部门需求",
              type: "page",
            },
            component: () => import(/* webpackChunkName: "rddepartmentalrequirements" */ '@/views/departmentalRequirements/index.vue'),
          }
        ]
      }, {
        path: "/personnelmanagement",
        name: "personnelmanagement",
        meta: {
          title: "人事管理",
          type: "page",
        },
        component: () => import(/* webpackChunkName: "personnelmanagement" */ '@/views/personnelManagement/pc/index.vue'),
      }, {
        path: "/trialproductioncenter",
        name: "trialproductioncenter",
        meta: {
          title: "试生产中心",
          type: "page"
        },
        component: () => import(/* webpackChunkName: "aftersalesmanagement" */ '@/views/productcenter/index.vue'),
        children: [
          // {
          //   path: "/closedloopproblemlist",
          //   name: "问题清单闭环",
          //   meta: {
          //     title: "问题清单闭环",
          //     type: "page"
          //   },
          //   component: () => import(/* webpackChunkName: "closedloopproblemlist" */ '@/views/trialProductionCenter/closedLoopProblem/index.vue')
          // },
          {
            path: "/failureanalysis",
            name: "失效分析",
            meta: {
              title: "失效分析",
              type: "page"
            },
            component: () => import(/* webpackChunkName: "failureanalysis" */ '@/views/trialProductionCenter/failureanalysis/index.vue'),
          },
          {
            path: "/rootcauseanalysis",
            name: "根本原因分析",
            meta: {
              title: "根本原因分析",
              type: "page"
            },
            component: () => import(/* webpackChunkName: "rootCauseAnalysis" */ '@/views/afterSaleRepair/pc/rootCauseAnalysis/index.vue'),
          },
          {
            path: "/trialserial",
            name: "机身编号",
            meta: {
              title: "机身编号",
              type: "page"
            },
            component: () => import(/* webpackChunkName: "rootCauseAnalysis" */ '@/views/trialProductionCenter/series/index.vue'),
          },
          {
            path: '/trialInstruction',
            name: "trialInstruction",
            meta: {
              title: '生产计划',
              type: 'page',
              produceOrTpc: "Tpc",
            },
            component: () => import(/* webpackChunkName: "trialInstruction" */ '@/views/productionInstruction/index.vue'),
          },
          {
            path: '/trialwarehouse',
            name: "trialwarehouse",
            meta: {
              title: '成品仓库',
              type: 'page',
              produceOrTpc: "Tpc",
            },
            component: () => import(/* webpackChunkName: "trialwarehouse" */ '@/views/productDaily/warehouse/index.vue'),
          },
          {
            path: "/trialinspectionissues",
            name: "trialinspectionissues",
            meta: {
              title: '质检问题',
              type: 'page',
              produceOrTpc: "Tpc",
            },
            component: () => import(/* webpackChunkName: "trialinspectionissues" */ '@/views/productDaily/problem/layout.vue'),
          },
          {
            path: '/trialinspection',
            name: "trialinspection",
            meta: {
              title: '日常质检',
              type: 'page',
              produceOrTpc: "Tpc",
            },
            component: () => import(/* webpackChunkName: "trialinspection" */ '@/views/productDaily/pc/index.vue'),
          },
          {
            path: '/trialproduct',
            name: "trialproduct",
            meta: {
              title: '日常生产',
              type: 'page',
              produceOrTpc: "Tpc",
            },
            component: () => import(/* webpackChunkName: "trialproduct" */ '@/views/productDaily/pc/produceIndex.vue'),
          },
        ]
      }, {
        path: "/transdepartment",
        name: "transdepartment",
        meta: {
          title: "跨部门管理",
          type: "default"
        },
        component: () => import(/* webpackChunkName: "aftersalesmanagement" */ '@/views/productcenter/index.vue'),
        children: [
          {
            path: "/rddepartmentalrequirements",
            name: "rddepartmentalrequirements",
            meta: {
              title: "部门需求",
              type: "page",
            },
            component: () => import(/* webpackChunkName: "departmentalRequirements" */ '@/views/departmentalRequirements/index.vue'),
          },
          {
            path: "/departmentannouncement",
            name: "departmentannouncement",
            meta: {
              title: "部门公告",
              type: "default",
            },
            component: () => import(/* webpackChunkName: "departmentannouncement" */ '@/views/transDepartment/departmentAnnouncement/index.vue'),
          },
        ]
      }, {
        path: "/brand",
        name: "brand",
        meta: {
          title: "品宣管理",
          type: "default"
        },
        component: () => import(/* webpackChunkName: "brand" */ '@/views/productcenter/index.vue'),
        children: [
          {
            path: "/literature",
            name: "literature",
            meta: {
              title: "产品资料",
              type: "default"
            },
            component: () => import(/* webpackChunkName: "literature" */ '@/views/brand/Literature/index.vue'),
          }
        ]
      }
    ]
  }
];

const mobileRoute = {
  '/brandcatalog': [
    {
      path: "/brandcatalog",
      name: "brandcatalog",
      meta: {
        title: "产品目录",
        type: 'default',
      },
      component: () => import(/* webpackChunkName: "brandcatalog" */ '@/views/brand/Catalog/index.vue'),
    }
  ],
  '/repairequipment': [
    {
      path: "/repair",
      name: 'repair',
      component: () => import(/* webpackChunkName: "repair" */ '@/views/repair/index.vue'),
    },
  ],
  '/menu': [
    {
      path: '/mobilemenu',
      name: 'mobileMenu',
      meta: {},
      component: () => import(/* webpackChunkName: "mobileMenu" */ '@/views/mobileMenu/index.vue'),
    }, {
      path: '/mobilemenu/pageaction',
      name: 'mobileMenuaction',
      meta: {},
      component: () => import(/* webpackChunkName: "mobileMenuaction" */ '@/views/mobileMenu/components/page/index.vue'),
    },
  ],
  '/aftersalerepair': [
    {
      path: "/mobileaftersalerepair",
      name: "mobileaftersalerepair",
      component: () => import(/* webpackChunkName: "mobileaftersalerepair" */ '@/views/afterSaleRepair/mobile/index.vue'),
    }, {
      path: "/mobileaftersalerepairform",
      name: "mobileaftersalerepairform",
      component: () => import(/* webpackChunkName: "mobileaftersalerepairform" */ '@/views/afterSaleRepair/mobile/form.vue'),
    }
  ],
  '/aftersalesmanagement': [
    {
      path: "/mobileaftersalesmanagement",
      name: "mobileaftersalesmanagement",
      component: () => import(/* webpackChunkName: "mobileaftersalesmanagement" */ '@/views/marketmanagement/mobile/index.vue')
    }
  ]
};


// 设置手机端路由
const mobileMenuPath = {
  '/repairequipment': '/repair',
  '/menu': '/mobilemenu',
  '/aftersalerepair': '/mobileaftersalerepair',
  '/aftersalesmanagement': '/mobileaftersalesmanagement',
  '/brandcatalog': '/brandcatalog'
};

export const addRoute: any = {
  path: '/dashboard',
  name: 'Dashboard',
  component: () => import(/* webpackChunkName: "layout" */'@/layout/index.vue'),
  children: [],
}

class menuManager {
  id: number;
  menuList: [];
  testMenu: [];
  userRoleList: number[];
  testRole: number[];
  constructor(id: number) {
    this.id = id;
    this.menuList = [];
    this.userRoleList = [];
    this.testMenu = [];
    this.testRole = [];
  }
  // 获取登录用户的权限
  getUserPermission() {
    return new Promise((resolve, reject) => {
      getPermissionsByUserId({ userId: this.id }).then((res) => {
        if (res.code === 200 && res.message === '成功') {
          if (this.id === 999 || this.id === 1000) {
            console.log('');
          } else {
            const authority = res.data.filter((id) => id !== 19);
            resolve(authority);
          }
          resolve(res.data);
        }
      });
    });
  }

  getMenu() {
    const flattenMenuList = [];
    const flatten = (list) => {
      list.forEach((item) => {
        flattenMenuList.push(item);

        if (item.children && item.children.length > 0) {
          flatten(item.children);
        }
      });
    };

    const setAuthority = (list, item) => {
      const menu = list.find((f) => f.id === item.pid);

      if (menu.meta === undefined) {
        menu.meta = {
          title: menu.name
        }
        menu.meta[item.identify] = true;
      } else {
        menu.meta[item.identify] = true;
      }
    };

    return new Promise((resolve, reject) => {
      this.getUserPermission().then((userPermission: any) => {
        if (userPermission.length === 0) resolve([]);
        getPermissionTree().then((res) => {
          // 扁平化数组
          flatten(res.data);
          // 去除无权限数据
          const filterPermissionList = flattenMenuList.filter((item) => {
            return userPermission.findIndex((f) => item.id === f) !== -1;
          })
          // 给页面赋予按钮权限
          const deleteAuthorityList = [];
          filterPermissionList.forEach((item) => {
            if (item.type == 2) {
              setAuthority(filterPermissionList, item);
              deleteAuthorityList.push(item.id);
            } else if (item.type == 1) {
              item.meta = item.meta === undefined ? { title: item.name } : item.meta;
            }
          });
          // 过滤按钮权限
          const list = filterPermissionList.filter((item) => (deleteAuthorityList.findIndex((f) => item.id === f) === -1));
          // 过滤一级页面
          const menu = list.filter((item) => item.pid === 0);

          const checkMenu = (list) => {
            // 去除无权限页面
            const menuList = list.filter((item) => {
              if (item.identify === '/menu') {
                return (store.state as any).user.user.isDL && userPermission.findIndex((f) => item.id === f) !== -1
              }
              return userPermission.findIndex((f) => item.id === f) !== -1;
            });

            menuList.forEach((item) => {
              item.children = item.children.filter((f) => f.type == 1).sort((a, b) => a.sort - b.sort);
              item.path = item.identify;
              item.name = item.identify.slice(1, item.identify.length);
              if (item.children.length === 0) {
                delete item.children
              } else {
                item.children = checkMenu(item.children)
              }
            });
            return menuList;
          };
          const authorityMenuList = checkMenu(menu);
          resolve(authorityMenuList);
        });
      });
    });
  }

  // 获取权限
  getTree() {
    return new Promise((resolve, reject) => {
      this.getUserPermission().then((userPermission: Array<number>) => {
        getPermissionTree().then((res) => {
          const list = [];
          if (res.code === 200 && res.message === '成功') {
            // 递归
            function ite(permissionsList) {
              permissionsList.forEach(item => {
                const userHasPermission = userPermission.find((permissionId) => permissionId === item.id) !== undefined;
                item.meta = {
                  title: item.name,
                }
                item.name = item.identify.slice(1, item.identify.length);
                item.path = item.identify;

                // 设置手机端菜单路由
                const isMobile = store.state.isMonile;
                if (isMobile && mobileMenuPath[item.path] !== undefined) {
                  item.path = mobileMenuPath[item.path];
                }

                item.children.forEach((subItem) => {
                  const userHasChildPermission = userPermission.find((permissionId) => permissionId === subItem.id) !== undefined;
                  if (Number(subItem.type) === 2 && userHasChildPermission) {
                    item.meta[subItem.identify] = true;
                  } else if (Number(subItem.type) === 1 && userHasChildPermission) {
                    ite([subItem])
                  }
                });
                if (item.children.length === 0) {
                  delete item.children;
                } else if (item.children[0].type == 2) {
                  delete item.children;
                }

                if (userHasPermission) {
                  console.log(item.id);
                  list.push(item)
                };
              });
            }
            ite(res.data);
          }
          resolve(list);
        });
      });
    }).catch((err) => {
      Toast('warning', '获取权限失败请重试', 3);
    });
  }

  // 比较路由权限
  compareRoute(permission) {
    const permissionList = [];
    const flatten = (list) => {
      list.forEach((item) => {
        permissionList.push(item);

        if (item.children && item.children.length > 0) {
          flatten(item.children);
        }
      });
    };
    flatten(permission);
    function ite(route) {
      return route.filter((item) => {
        if (item.children) {
          item.children = ite(item.children);
        }
        const hasRoute = permissionList.find((findPermission) => item.path === findPermission.identify);
        if (hasRoute) {
          item.meta = Object.assign(item.meta, hasRoute.meta);
        }
        return hasRoute !== undefined || item.meta.type === 'default';
      });
    }
    // let permissionRoute = ite(permissionList);
    let permissionRoute = store.state.isMonile ? ite(permissionList) : ite(routerArr);
    // 手机端路由
    if (store.state.isMonile) {
      const mobileRouteList = [];
      permissionRoute.forEach((route) => {
        if (mobileRoute[route.path] !== undefined) {
          mobileRoute[route.path][0].meta = Object.assign(route.meta, mobileRoute[route.path][0].meta);
          mobileRouteList.push(...mobileRoute[route.path]);
        }
      });
      permissionRoute.push(...mobileRouteList);
    }

    permissionRoute.forEach((route) => {
      router.addRoute(route);
    });
  }

  findRoute() {
    return new Promise((resolve) => {
      this.getMenu().then((permission: any) => {
        permission = permission.sort((a, b) => a.sort - b.sort).filter((f) => f.name !== 'brandcatalog');
        store.commit('SET_MENU_INFO', permission);
        this.compareRoute(permission);
        resolve(permission);
      });
    })
  }

}

export default menuManager
